import { render, staticRenderFns } from "./BcbCampaignDetail.vue?vue&type=template&id=48c42b72&scoped=true"
import script from "./BcbCampaignDetail.vue?vue&type=script&lang=js"
export * from "./BcbCampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignDetail.vue?vue&type=style&index=0&id=48c42b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c42b72",
  null
  
)

export default component.exports